import React from 'react';
import { methodCallFromString } from "../../modules/utils";
export default function FormWrapper({ onSubmit, children, id }) { return /*#__PURE__*/ React.createElement("form", { noValidate: true, onSubmit: methodCallFromString(onSubmit), id: id }, children); }
